<template>
  <v-container 
    fluid
    class="px-8">
    <div 
      v-if="!!property.contracts"
      class="px-0 d-flex flex-wrap justify-space-between">
      <v-col cols="8" sm="3" class="px-0">
        <v-select
          flat
          :items="property.contracts"
          :item-text="item => itemName(item)"         
          item-value="id"
          :label="selected"
          v-model="property.activeContract.id"
          hide-details
          solo-inverted
          >
          </v-select>
      </v-col>
      <v-col
        cols="4"
        sm="2"
        class="text-right px-0"
        >
        <v-btn
          text
          primary
          @click="$router.push({ name: 'Contract', params: { id: property.activeContract.id } })"
          >
          {{ $t('property.detail.show_contract') }}
        </v-btn>
      </v-col>
    </div>
    <v-row 
      v-if="!!property.activeContract"
      class="d-flex justify-start align-start">
      <v-col 
        lg="4"
        sm="6"
        cols="12">
        <PanelOne :contract="property.activeContract"/>
      </v-col>
      <v-col 
        lg="4"
        sm="6"
        cols="12">
        <PanelTwo :contract="property.activeContract"/>
      </v-col>
      <v-col 
        lg="4"
        sm="6"
        cols="12">
        <PanelThree :contract="property.activeContract"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import PanelOne from '@/components/contracts/show/PanelOne'
  import PanelTwo from '@/components/contracts/show/PanelTwo'
  import PanelThree from '@/components/contracts/show/PanelThree'

  export default {
    name: "ShowContract",
    components:{
      PanelOne,
      PanelTwo,
      PanelThree
    },
    props: ['property'], 
    data() {
      return{
        selected: "",
      }
    },
    methods: {
      itemName(item) {
        let date1 = "Sin fecha de Inicio"
        let date2 = "Sin fecha de Fin"
        if (item.startsAt) {
          let startDate = item.startsAt.split('-')
          date1 = startDate[2] + '/' + startDate[1] + '/' + startDate[0]
        }
        if (item.endsAt) {
          let endDate = item.endsAt.split('-')
          date2 = endDate[2] + '/' + endDate[1] + '/' + endDate[0]
        }
        return 'Contrato Nº '+item.id + ' ('+ date1 + ' - ' + date2 +')'
      }
    }
  }
</script>
